import { ForceSubmissionConflictReason } from '@evidentid/tprm-portal-lib/models/entity-details';

export const FORCE_SUBMISSION_CONFLICT_MESSAGE =
    'This verification changed before processing could be forced. The latest status is shown.';
export const FORCE_SUBMISSION_AUTOMATED_CHECK_MESSAGE =
    'Processing can\'t be forced while an automated check is still pending.';
export const FORCE_SUBMISSION_ERROR_MESSAGE = 'Processing could not be forced. Please try again.';

export function getForceSubmissionConflictMessage(reason: ForceSubmissionConflictReason | null): string {
    return reason === ForceSubmissionConflictReason.UNSUPPORTED_MISSING_REQUIREMENT
        ? FORCE_SUBMISSION_AUTOMATED_CHECK_MESSAGE
        : FORCE_SUBMISSION_CONFLICT_MESSAGE;
}

/** Shown in place of the Force Processing button when the server would refuse it. */
export function getForceSubmissionUnavailableText(reason: ForceSubmissionConflictReason): string {
    return reason === ForceSubmissionConflictReason.UNSUPPORTED_MISSING_REQUIREMENT
        ? 'Processing can\'t be forced while an automated check is still pending.'
        : 'Processing can\'t be forced right now.';
}

// TODO(PRODUCT-26909): replace the modal copy below with the wording design sends.
export function getForceSubmissionReceivedSentence(receivedCount: number): string {
    return receivedCount === 1
        ? 'The 1 response received will be sent for review now.'
        : `The ${receivedCount} responses received will be sent for review now.`;
}

/** For requirements asked for the first time or again after a non-compliant result: no coverage to keep. */
export function getForceSubmissionNonCompliantSentence(names: string[]): string {
    const verb = names.length === 1 ? 'has' : 'have';
    return `${names.join(', ')} ${verb} no response and will be marked non-compliant.`;
}

/** For expiring requirements: the coverage already on file is kept, so their status holds until it expires. */
export function getForceSubmissionExpiringSentence(names: string[]): string {
    return names.length === 1
        ? `${names[0]} has no response, so its current coverage stays in place until it expires.`
        : `${names.join(', ')} have no response, so their current coverage stays in place until it expires.`;
}

/**
 * For on-demand requirements. They usually have coverage on file, which is kept, but the portal can't tell, so this
 * claims neither outcome.
 */
export function getForceSubmissionOnDemandSentence(names: string[]): string {
    return names.length === 1
        ? `${names[0]} has no response, so it's evaluated on the coverage already on file.`
        : `${names.join(', ')} have no response, so they're evaluated on the coverage already on file.`;
}

/**
 * Names no recipient and promises no email: the follow-up request only exists once the received responses are reviewed,
 * and whether it is emailed, and to the entity or its producers, depends on the client's notification settings.
 */
export function getForceSubmissionNewLinkSentence(): string {
    return 'A new request for what\'s missing will be created once the received responses are reviewed.';
}

export function getForceSubmissionSecondRequestWarning(entityName: string): string {
    return `This is already a second request. Forcing processing will make ${entityName} exhausted, `
        + 'and no new request will follow for these unless another request goes out.';
}
